import SequencePrimer from 'molbio/primers/backbone/SequencePrimer';

interface NamedModel {
  name(): string;
  displayLabel?(): string;
}

export default function getNucleotideAwareDisplayName(component: NamedModel): string {
  let name = component.displayLabel ? component.displayLabel() : component.name();
  if (component instanceof SequencePrimer) {
    name = `${name} (${component.nucleotideType()})`;
  }
  return name;
}
